export default {
  userProfile: {
    header: {
      title: "Ajustes do perfil",
      subtitle: "Gerencie seu perfil Linemate",
    },
    sections: {
      accountDetails: "Detalhes da conta",
      billing: "Cobrança",
    },
    labels: {
      oldPassword: "Senha antiga",
      newPassword: "Nova senha",
      confirmNewPassword: "Confirmar nova senha",
      enterYourPassword: "Digite sua senha",
      showAll: "Mostrar tudo",
    },
    descriptions: {
      changePassword: "Altere a senha da sua conta Linemate",
      preferredOdds: "Escolha suas odds preferidas para tendências e Minhas escolhas",
      language: "Selecione o idioma em que você quer que o Linemate seja exibido.",
      odds: "Selecione o formato em que você quer que as odds sejam exibidas.",
      theme: "Selecione como o Linemate é exibido.",
      billingPrimary: "Acompanhe seu plano e opções de pagamento",
      billingSecondary: "A Linemate usa a Stripe para simplificar a cobrança e o gerenciamento de pagamentos.",
      deleteAccount: "Excluir sua conta e dados da conta",
      deleteAccountSecondary: "Se quiser excluir permanentemente sua conta, você pode fazer isso à direita.",
    },
    actions: {
      update: "Atualizar",
      choosePreferredOdds: "Escolher suas odds preferidas",
      saveMyChoices: "Salvar minhas escolhas",
      manageBilling: "Gerenciar cobrança",
      deleteThisAccount: "Excluir esta conta",
    },
    deleteAccount: {
      confirmMessage: "Tem certeza de que deseja excluir sua conta? Se sim, continue abaixo.",
      permanentWarning: "Lembre-se de que todos os seus dados serão removidos permanentemente dos nossos servidores. Esta ação encerrará sua assinatura no próximo período de cobrança e não poderá ser desfeita.",
      acknowledgment: "Reconheço que todos os dados desta conta serão excluídos e quero continuar.",
    },
    validation: {
      passwordRequirements: "A senha precisa incluir uma letra maiúscula, uma letra minúscula e ter pelo menos 8 caracteres.",
      confirmPasswordMismatch: "A confirmação da senha não corresponde.",
      incorrectPassword: "Senha incorreta.",
    },
  },
};
